module.exports = __webpack_public_path__ + "images/referenzen/imagefilm/seiko_imagefilm.jpg";